var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "slider-body",
      attrs: { id: "slider-body-" + _vm.group.groupId }
    },
    [
      _c(
        "div",
        {
          staticClass: "slider-content",
          attrs: { id: "slider-group-" + _vm.group.groupId }
        },
        [
          _vm.isScroll && _vm.showPrev && !_vm.mobileBigAndBelow
            ? _c(
                "button",
                {
                  staticClass: "prev-btn casino-slider-btn",
                  attrs: { id: "prev-btn-" + _vm.group.groupId },
                  on: {
                    click: function($event) {
                      return _vm.slide("prev")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("arrow_back_ios")])],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item-list",
              class: [
                { "has-scroll": _vm.isScroll },
                { double: _vm.group.groupName === "Slots 2" },
                _vm.section
              ],
              attrs: {
                id: "item-list-" + _vm.group.groupId,
                "data-item-list-id": _vm.group.groupId
              }
            },
            _vm._l(_vm.group.gameIds, function(gameId, i) {
              return _c("casino-slider-item", {
                key: gameId,
                ref: "childRef",
                refInFor: true,
                staticClass: "item",
                class: [
                  { "first-item": i === 0 },
                  { "last-item": _vm.group.gameIds.length - 1 === i },
                  _vm.section
                ],
                attrs: {
                  section: _vm.section,
                  gameId: gameId,
                  iterator: i,
                  "data-gid": _vm.group.gameId,
                  gameInfoData: _vm.getGameInfoDataByGameId(
                    _vm.gamesByGroup,
                    gameId,
                    _vm.group.groupName
                  ),
                  isFavorite: _vm.isInFavorite(gameId)
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.isScroll && _vm.showNext && !_vm.mobileBigAndBelow
            ? _c(
                "button",
                {
                  staticClass: "next-btn casino-slider-btn",
                  attrs: { id: "next-btn-" + _vm.group.groupId },
                  on: {
                    click: function($event) {
                      return _vm.slide("next")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("arrow_forward_ios")])],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb155388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb155388","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoSlider.vue
// module id = null
// module chunks = 